import { useEffect, useState } from 'react'

export const useWaitForElement = (selector: string): boolean => {
  const [ready, setReady] = useState<boolean>(false)

  useEffect(() => {
    if (selector) {
      const check = () => {
        const el = document.querySelector(selector)
        const isVisible = el && (el as HTMLElement).offsetParent !== null
        setReady(Boolean(isVisible))
      }

      check()
      const interval = setInterval(check, 200)
      return () => clearInterval(interval)
    }
  }, [selector])

  return ready
}
